import styled from 'styled-components';

import BaseCardRow from 'components/CardRow';

export const CardRow = styled(BaseCardRow)`
  align-items: center;
  gap: 0 0.5rem;
`;
